import { Component, OnInit, Input } from '@angular/core';

import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import {MatTableDataSource} from '@angular/material/table';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';
import {TranslateService} from '@ngx-translate/core';

export interface Secciones {
  orden: number;
  pregunta: string;
  siempre: number;
  casiSiempre: number;
  algunasVeces: number;
  casiNunca: number;
  nunca: number;
}

const ELEMENT_DATA: Secciones[] = [
  {orden:1, pregunta: 'El espacio donde trabajo me permite realizar mis actividades de manera segura e higiénica', siempre:21, casiSiempre:76, algunasVeces:41, casiNunca:12, nunca:3 },
  {orden:2, pregunta: 'Mi trabajo me exige hacer mucho esfuerzo físico', siempre:21, casiSiempre:76, algunasVeces:41, casiNunca:12, nunca:3 },
  {orden:3, pregunta: 'Me preocupa sufrir un accidente en mi trabajo', siempre:21, casiSiempre:76, algunasVeces:41, casiNunca:12, nunca:3 },
  {orden:4, pregunta: 'Considero que en mi trabajo se aplican las normas de seguridad y salud en el trabajo', siempre:21, casiSiempre:76, algunasVeces:41, casiNunca:12, nunca:3 },
  {orden:5, pregunta: 'Considero que las actividades que realizo son peligrosas', siempre:21, casiSiempre:76, algunasVeces:41, casiNunca:12, nunca:3 },
];

@Component({
  selector: 'app-frp-respuestas-encuesta',
  templateUrl: './frp-respuestas-encuesta.component.html',
  styleUrls: ['./frp-respuestas-encuesta.component.scss']
})
export class FrpRespuestasEncuestaComponent implements OnInit {
  @Input() productoID: any;
  @Input() centroDeTrabajoId:any;
  totalColaboradores:number;
  displayedColumns: string[] = ['orden', 'pregunta', 'siempre', 'casi siempre', 'algunas veces', 'casi nunca', 'nunca'];
  dataSource = ELEMENT_DATA;
  titulo:string;
  tablaRespuestas: MatTableDataSource<backInter.ResultadoFactores>;
  urlCTIndividual:any;
  cargando:boolean=true;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private translateSrv: TranslateService
  ) {
    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.getGeneralesCT();
    this.respuestasEncuestaFactores();
  }

  respuestasEncuestaFactores(){
    let data={
      productoId: this.productoID,
      id_CT:this.centroDeTrabajoId
    }
    if(localStorage.getItem('empresaPadre')){
      this.urlCTIndividual=localStorage.getItem('empresaPadre');
    }
    else{
      this.urlCTIndividual="";
    }

    this.wizardService.respuestasEncuestaFactores(this.urlCTIndividual, data).subscribe( (datos: backInter.respuestasFactores) => {
      console.log(datos);
      this.tablaRespuestas = new MatTableDataSource(datos.result);
      // this.cargando=false;
    });
  }

  getGeneralesCT(){
    let menos50 = 'SECCIONES.FR_RESPUESTAS_ENCUESTA.TITULO-50';
    let mas50 = 'SECCIONES.FR_RESPUESTAS_ENCUESTA.TITULO2+50';
    this.translateSrv.get(menos50).subscribe((res: string) => { menos50 = res; });
    this.translateSrv.get(mas50).subscribe((res: string) => { mas50 = res; });
    let data={
      productoId: this.productoID,
      id_CT:this.centroDeTrabajoId
    }
    if(localStorage.getItem('empresaPadre')){
      this.urlCTIndividual=localStorage.getItem('empresaPadre');
    }
    else{
      this.urlCTIndividual="";
    }
    this.wizardService.getGeneralesCT(this.urlCTIndividual, data).subscribe( (datos: backInter.GeneralesCentrosDeTrabajo) => {
      console.log(datos);
      this.totalColaboradores=datos.totalColaboradores;
      if(this.totalColaboradores<50){
        this.titulo=menos50;
      }
      else{
        this.titulo=mas50;
      }
      this.cargando=false;
    });
  }

}
